import * as echarts from 'echarts/core';
import { LineChart } from 'echarts/charts';
import {
  TitleComponent,
  GridComponent,
  LegendComponent,
  TooltipComponent,
} from 'echarts/components';
import { CanvasRenderer } from 'echarts/renderers';
import { useEffect, useRef } from 'react';
import { useSize } from 'ahooks';

echarts.use([
  LegendComponent,
  TitleComponent,
  GridComponent,
  TooltipComponent,
  CanvasRenderer,
  LineChart,
]);

interface Props {
  data: Array<any>;
}

const LineOMS: React.FC<Props> = ({ data }: Props) => {
  const chartRef = useRef<any>(null);
  const pieChart = useRef<any>(null);
  const size = useSize(document.body);

  useEffect(() => {
    const pieOption: any = {
      tooltip: {
        trigger: 'axis',
      },
      color: ['#1890FF', '#FF4D4F'],
      legend: {
        bottom: '1%',
        left: 'center',
        icon: 'circle',
        itemHeight: 8,
        data: ['Total', 'Delayed'],
      },
      grid: {
        containLabel: true,
      },
      xAxis: {
        type: 'category',
        data: [
          'Jan',
          'Feb',
          'Mar',
          'Apr',
          'May',
          'Jun',
          'Jul',
          'Aug',
          'Sep',
          'Oct',
          'Nov',
          'Dec',
        ],
        name: 'MONTH',
        nameLocation: 'middle',
        nameGap: 30,
        nameTextStyle: {
          color: '#999',
          fontSize: 11,
          fontWeight: 500,
          letterSpacing: 0.5,
        },
        boundaryGap: false,
        axisTick: { show: false },
        axisLine: {
          lineStyle: {
            color: '#EAEAEA',
          },
        },
        axisLabel: {
          color: '#545454b3',
        },
      },
      yAxis: {
        type: 'value',
        name: 'COUNT',
        nameLocation: 'middle',
        nameGap: 40,
        nameTextStyle: {
          color: '#999',
          fontSize: 11,
          fontWeight: 500,
          letterSpacing: 0.5,
        },
        interval: 10,
        min: 0,
        max: 50,
        splitLine: {
          lineStyle: {
            type: 'dashed',
            color: '#E8E8E8',
          },
        },
      },
      series: [
        {
          name: 'Total',
          type: 'line',
          smooth: true,
          symbol: 'circle',
          symbolSize: 6,
          data: [38, 32, 45, 40, 35, 42, 38, 30, 36, 40, 35, 34],
        },
        {
          name: 'Delayed',
          type: 'line',
          smooth: true,
          symbol: 'circle',
          symbolSize: 6,
          data: [5, 3, 8, 4, 3, 6, 4, 2, 3, 5, 4, 3],
        },
      ],
    };
    if (!pieChart.current) {
      pieChart.current = echarts.init(
        chartRef.current as unknown as HTMLDivElement,
        undefined,
        {
          height: 400,
        },
      );
    }
    pieChart.current?.setOption(pieOption);
  }, [data]);

  useEffect(() => {
    pieChart.current?.resize();
  }, [size]);

  return <div ref={chartRef} />;
};

export default LineOMS;
